<div
  class="ticket-container state-success d-flex flex-column flex-md-row"
  [class.light]="isLight"
  [class.dark]="!isLight"
>
  <div class="main-info-wrapper w-100">
    <div class="main-info gap-3">
      <div class="icon">
        <app-icam-icon iconName="check" [isDefault]="true" iconHeight="35px"></app-icam-icon>
      </div>
      <div class="flex-grow-1">
        <h3 class="title fw-semibold my-0 py-0 title-success">
          <span> TICKET {{ ticket.caseNumber }} </span>
        </h3>
        <span class="ticket-status">
          {{ 'TICKET.TICKET_OK' | translate | uppercase }}
        </span>
      </div>
    </div>
  </div>
  <div class="details-container w-100">
    <div></div>
    <div class="details">
      <div class="state-three-details">
        <div class="item">
          <span class="fw-bold">{{ 'TICKET.ERROR_CODE' | translate }}: </span>
          @if (ticket.errorMessage) {
            <span>{{ ticket.errorMessage }}</span>
          } @else {
            <span>{{ 'TABLE.DEFAULT_MESSAGES_IF_EMPTY.TICKET_DESCRIPTION' | translate }}</span>
          }
        </div>
        <div class="item">
          <span class="fw-bold">{{ 'TICKET.OPEN_DATE' | translate }}: </span>
          @if (ticket.createdDate) {
            <span>{{ ticket.createdDate | date: 'dd/MM/yyyy' }}</span>
          } @else {
            <span>{{ '-' }}</span>
          }
        </div>
        <div class="item">
          <span class="fw-bold">{{ 'TICKET.CLOSE_DATE' | translate }}: </span>
          @if (ticket.closedDate) {
            <span>{{ ticket.closedDate | date: 'dd/MM/yyyy' }}</span>
          } @else {
            <span>{{ '-' }}</span>
          }
        </div>
        @if (isSolutionOpen) {
          <div class="solution-details">
            <div class="item new-item">
              <span class="fw-bold">{{ 'TICKET.SOLUTION' | translate }}: </span>
              <span>{{ ticket.resolution || ('TICKET.NO_SOLUTION' | translate) }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="button-container w-100">
    <div
      class="solution-toggle"
      (click)="isSolutionOpen = !isSolutionOpen"
      (keydown.enter)="isSolutionOpen = !isSolutionOpen"
      tabindex="0"
      role="button"
    >
      <p class="m-0 p-0 text-decoration-underline">
        {{ 'TICKET.SOLUTION_TAKEN' | translate }}
        <span>{{ isSolutionOpen ? '-' : '+' }}</span>
      </p>
    </div>
  </div>
</div>
